import { useState } from "react"
import { FormInput } from "../../components/forms/form-input"
import { SiteHeader } from "../../components/header/header"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useAuthentication } from "../../services/authentication/authentication.context";
import { LoadingIndicator } from "../../components/utils/loader";
import { AppAlert } from "../../components/utils/alert";
import { isNull } from "../../_helpers/isNull";

export const ResetPassword = () => {

    const { isLoading, passwordRecovery } = useAuthentication();

    const resetToken = new URLSearchParams(window.location.search).get('token') || 'ttyDYA4eO5UG34';

    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('')

    const [showPassword, setShowPassword] = useState(false);
    const [showRepeat, setShowRepeat] = useState(false);

    const [onAlert, setOnAlert] = useState();

    const handleSubmit = async () => {
        if (isNull(password)) {
            setOnAlert({
                caption: 'Invalid password!',
                message: 'Please provide a value for the password.',
                accept: 'Ok',
                onAccept: () => setOnAlert()
            });

            return;
        }

        if (password.length < 8) {
            setOnAlert({
                caption: 'Invalid password!',
                message: 'Password is too short. It must be at least 8 characters!',
                accept: 'Ok',
                onAccept: () => setOnAlert()
            });

            return;
        }

        if (password !== repeatPassword) {
            setOnAlert({
                caption: 'Mismatch!',
                message: 'Passwords do not match!.',
                accept: 'Ok',
                onAccept: () => setOnAlert()
            });

            return;
        }

        

        const resp = await passwordRecovery({ password, repeatPassword }, resetToken);

        if (resp?.error) {
            setOnAlert({
                caption: 'Error!',
                message: resp?.error,
                accept: 'Ok',
                onAccept: () => setOnAlert()
            });

            return;
        }

        setOnAlert({
            caption: 'Success!',
            message: resp?.message,
            accept: 'Ok',
            onAccept: () => {
                setPassword('');
                setRepeatPassword('');
                setOnAlert();
            }
        });

        return;
    }

    return (
        <div className="app-body">
            <SiteHeader pageTitle={'Reset Password'} />
            {isLoading && <LoadingIndicator />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    onAcept={onAlert.onAccept}
                    onClose={() => setOnAlert()}
                />
            )}
            <div className="slogan-1 login-cap">WELCOME BACK</div>
            <div className="slogan-2 login-cap">Reset your password</div>
            <div className="form-container">
                <div className="login-form">
                    <FormInput
                        type={showPassword ? 'text' : 'password'}
                        name={'password'}
                        value={password}
                        label={"Password"}
                        formIcon={showPassword ? faEyeSlash : faEye}
                        toggleIcon={(e) => {
                            e.preventDefault();
                            setShowPassword((show) => !show)
                        }}
                        onChange={(e) => setPassword(e.target.value)}
                        required={true}
                    />
                    <FormInput
                        type={showRepeat ? 'text' : 'password'}
                        name={'repeatPassword'}
                        value={repeatPassword}
                        label={"Repeat password"}
                        formIcon={showRepeat ? faEyeSlash : faEye}
                        toggleIcon={(e) => {
                            e.preventDefault();
                            setShowRepeat((show) => !show)
                        }}
                        onChange={(e) => setRepeatPassword(e.target.value)}
                        required={true}
                    />
                    <button
                        className="form-button"
                        onClick={async () => await handleSubmit()}
                    >
                        Reset Password
                    </button>
                </div>
            </div>
        </div>
    )
}